import { useState } from "react";
import { Globe2, Newspaper, Palette } from "lucide-react";

// Six quiet palettes, chosen by the publisher's name so a paper always looks the same.
const SKINS = [
  "from-[#0f2a3f] via-[#123049] to-[#0b1b2a]",
  "from-[#2b1d3a] via-[#38264b] to-[#1a1226]",
  "from-[#0f3330] via-[#14423c] to-[#0a2320]",
  "from-[#3a2418] via-[#4a2f1e] to-[#241610]",
  "from-[#1c2a4a] via-[#243559] to-[#131c30]",
  "from-[#33202b] via-[#442a38] to-[#20141b]",
];

const skinFor = (text) => {
  let n = 0;
  for (const ch of String(text || "news")) n = (n * 31 + ch.charCodeAt(0)) % 997;
  return SKINS[n % SKINS.length];
};

// When a publisher gives us no picture, the card still gets something to look at.
export const StoryTile = ({ source, label, skin, onSkin }) => {
  const [open, setOpen] = useState(false);
  const dressed = Number.isInteger(skin) ? SKINS[skin % SKINS.length] : skinFor(source);

  return (
    <div
      data-testid="story-tile"
      className={`relative flex h-32 w-full items-end bg-gradient-to-br ${dressed} p-3`}
    >
      <Newspaper className="absolute right-3 top-9 h-10 w-10 text-white/10" />
      <div className="relative">
        <p className="flex items-center gap-1.5 text-[10px] uppercase tracking-[0.2em] text-white/45">
          <Globe2 className="h-3 w-3" /> {label || "Story"}
        </p>
        <p className="mt-1 max-w-[85%] truncate text-sm font-semibold text-white/80">{source}</p>
      </div>

      {onSkin && (
        <button
          data-testid="tile-skin-open"
          aria-label={`Choose a colour for ${source}`}
          onClick={(e) => { e.preventDefault(); setOpen((o) => !o); }}
          className="absolute right-2 top-2 rounded-full bg-black/30 p-1.5 text-white/60 transition-colors hover:text-white"
        >
          <Palette className="h-3.5 w-3.5" />
        </button>
      )}

      {open && (
        <div className="absolute right-2 top-9 flex gap-1 rounded-full bg-black/60 p-1.5 backdrop-blur"
             data-testid="tile-skin-picker">
          {SKINS.map((look, i) => (
            <button
              key={i}
              data-testid={`tile-skin-${i}`}
              aria-label={`Colour ${i + 1}`}
              onClick={(e) => { e.preventDefault(); setOpen(false); onSkin(i); }}
              className={`h-4 w-4 rounded-full bg-gradient-to-br ${look} ring-1 ${
                skin === i ? "ring-white" : "ring-white/25"}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};
